module.exports = __webpack_public_path__ + "img/atom-shape.8bff1271.svg";